module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-manage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("设备绑定申请")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-select', {
    model: {
      value: (_vm.keyType),
      callback: function($$v) {
        _vm.keyType = $$v
      },
      expression: "keyType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "用户ID",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "姓名",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "手机号",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "学号",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "申请中",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通过",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未通过",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "width": "70px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "用户ID",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "width": "125px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stuId",
      "label": "学号/教职工号",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "campuszones",
      "label": "校区",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "className",
      "label": "院系",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请设备信息",
      "show-overflow-tooltip": ""
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', {
            staticStyle: {
              "line-height": "40px",
              "display": "inline-block"
            },
            on: {
              "click": function($event) {
                return _vm.showImg(_vm.row)
              }
            }
          }, [_vm._v(_vm._s(_vm.row.customDeviceId))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "用户已绑定次数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.isPassed == 0) ? _c('div', [_c('el-button', {
            staticClass: "optionbtn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.checkCompalinPass(_vm.row)
              }
            }
          }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
            staticClass: "optionbtn",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.checkCompalinNot(_vm.row)
              }
            }
          }, [_vm._v("不通过")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.isPassed !== 0) ? _c('div', [(_vm.row.isPassed == 1) ? _c('span', {
            staticClass: "optionbtnss"
          }, [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (_vm.row.isPassed == 2) ? _c('span', {
            staticClass: "optionbtnss"
          }, [_vm._v("未通过")]) : _vm._e()]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.totalCount > 0),
      expression: "this.totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": 10,
      "current-page": _vm.currentPage,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设备信息详情",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialogcont"
  }, [_c('p', [_vm._v("设备类型：" + _vm._s(_vm.osType))]), _vm._v(" "), _c('p', [_vm._v("设备型号：" + _vm._s(_vm.deviceModel))]), _vm._v(" "), (_vm.imei) ? _c('p', [_vm._v("imei：" + _vm._s(_vm.imei))]) : _vm._e(), _vm._v(" "), (_vm.androidId) ? _c('p', [_vm._v("androidId：" + _vm._s(_vm.androidId))]) : _vm._e(), _vm._v(" "), (_vm.idfa) ? _c('p', [_vm._v("idfa：" + _vm._s(_vm.idfa))]) : _vm._e(), _vm._v(" "), (_vm.deviceId) ? _c('p', [_vm._v("deviceId：" + _vm._s(_vm.deviceId))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("逻辑分辨率：" + _vm._s(_vm.logicPixel))]), _vm._v(" "), _c('p', [_vm._v("物理分辨率：" + _vm._s(_vm.physicPixel))]), _vm._v(" "), (_vm.blMac) ? _c('p', [_vm._v("蓝牙MC：" + _vm._s(_vm.blMac))]) : _vm._e(), _vm._v(" "), (_vm.wifiMac) ? _c('p', [_vm._v("WiFiMC：" + _vm._s(_vm.wifiMac))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("CPU型号：" + _vm._s(_vm.cpuModel))]), _vm._v(" "), _c('p', [_vm._v("是否root：" + _vm._s(_vm.isRoot))]), _vm._v(" "), (_vm.appUpdateTime) ? _c('p', [_vm._v("App更新时间：" + _vm._s(_vm.appUpdateTime))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("App安装时间：" + _vm._s(_vm.appInstallTime))]), _vm._v(" "), _c('p', [_vm._v("设备指纹：" + _vm._s(_vm.fingerprint))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30aecbeb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/device/deviceComplain.vue
// module id = 980
// module chunks = 0